<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("preloader", ["preloader"])
  }
};
</script>

<template>
  <transition name="fade" mode="out-in">
    <div v-show="preloader" class="preloader">
      <img src="../../../static/broom.gif" alt="Carregando...">
    </div>
  </transition>
</template>

<style scoped>
.preloader {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: linear-gradient(
    45deg,
    rgba(96, 50, 133, 0.9) 0%,
    rgba(175, 0, 107, 0.9) 100%
  );
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Preloader.vue